import { fetchData } from "@client";

export async function fetchProjectCommentsQuery(uuid) {
  const res = await fetchData(`/project/comments/${uuid}`);
  return res.results?.comments;
}
